export const AlinPatron = require('images/about-us/redesign/AlinPatron.webp');
export const ByronKeithAdams = require('images/about-us/redesign/ByronKeithAdams.webp');
export const ChadRicher = require('images/about-us/redesign/ChadRicher.webp');
export const IanDickey = require('images/about-us/redesign/IanDickey.webp');
export const GregMaes = require('images/about-us/redesign/GregMaes.webp');
export const IvanGalkin = require('images/about-us/redesign/IvanGalkin.webp');
export const JosephDiMelis = require('images/about-us/redesign/JosephDiMelis.webp');
export const MihaelaPoiata = require('images/about-us/redesign/MihaelaPoiata.webp');
export const SergheiBusmachi = require('images/about-us/redesign/SergheiBusmachi.webp');
export const LoganBerlin = require('images/about-us/redesign/LoganBerlin.webp');

export const AnthonyRich = require('images/about-us/redesign/AnthonyRich.webp');
export const CharlesBurkeCowley = require('images/about-us/redesign/CharlesBurkeCowley.webp');
export const CharlesHouser = require('images/about-us/redesign/CharlesHouser.webp');
export const DenisMezer = require('images/about-us/redesign/DenisMezer.webp');
export const IgorPapo = require('images/about-us/redesign/IgorPapo.webp');
export const JoshuaStewart = require('images/about-us/redesign/JoshuaStewart.webp');
export const KyleClausen = require('images/about-us/redesign/KyleClausen.webp');
export const MattLutton = require('images/about-us/redesign/MattLutton.webp');
export const KevinBrophy = require('images/about-us/redesign/KevinBrophy.webp');
export const PhilipBayne = require('images/about-us/redesign/PhilipBayne.webp');
export const QuranOsiris = require('images/about-us/redesign/QuranOsiris.webp');
export const RimaNemtu = require('images/about-us/redesign/RimaNemtu.webp');
export const SergeyBogutsky = require('images/about-us/redesign/SergeyBogutsky.webp');
export const SergiuRobu = require('images/about-us/redesign/SergiuRobu.webp');
export const JonWilburn = require('images/about-us/redesign/JonWilburn.webp');
